import { Cron } from '@modules/common/types';
import { DAYS_EXCLUDING_WEEKENDS } from '@modules/subscribe/components/SubscribeDrawerV2/OutboundFrequencyCard/constants';

export const DAILY_FREQUENCY_DEFAULT_CRON_VALUE_V2: Cron = {
  realtime: false,
  valueV2: {
    hourOfDay: 0,
    dayOfWeek: DAYS_EXCLUDING_WEEKENDS,
  },
};

export const GENERATED_RECORDS_WARNING_COUNT = 50;
export const SEARCH_SUBSCRIPTION_HELPCENTER_URL =
  'https://helpcenter.enterpret.com/en/articles/6771467-search';
